import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[locale]/signup/page.tsx");
